import {
  MarkerClustererF as GoogleMapsMarkerClusterer,
  MarkerClustererProps as GoogleMapsMarkerClustererProps
} from "@react-google-maps/api";
import {Clusterer} from "@react-google-maps/marker-clusterer";
import {Key} from "react";
import {uniqueId} from "lodash";

export type MarkerClustererProps = Omit<GoogleMapsMarkerClustererProps, 'imagePath'>

export const MarkerClusterer = (props: MarkerClustererProps) => {
  const {children, options, ...rest} = props;

  return (
    <GoogleMapsMarkerClusterer
      {...rest}
      options={{
        ...options,
        imagePath: "/m"
      }}
    >
      {children}
    </GoogleMapsMarkerClusterer>
  );
};

export const getClusterMarkerOpts = (key: Key, index: number, totalCount: number, clusterer?: Clusterer): {
  key: Key,
  noClustererRedraw?: boolean
} => {
  let noClustererRedraw: boolean | undefined = undefined;
  if (typeof clusterer !== "undefined") {
    if (index === totalCount - 1) {
      noClustererRedraw = false;
      key = key + "-redrawer-" + uniqueId();
    } else {
      noClustererRedraw = true;
    }
  }

  return {
    key,
    noClustererRedraw
  };
};
